// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__FJl7f","content":"ManualTimeModal_content__dNYBi"};